import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './error-message.reducer';

export const ErrorMessageDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const errorMessageEntity = useAppSelector(state => state.errorMessage.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="errorMessageDetailsHeading">
          <Translate contentKey="crawlerBackendApp.errorMessage.detail.title">ErrorMessage</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{errorMessageEntity.id}</dd>
          <dt>
            <span id="language">
              <Translate contentKey="crawlerBackendApp.errorMessage.language">Language</Translate>
            </span>
          </dt>
          <dd>{errorMessageEntity.language}</dd>
          <dt>
            <span id="errorCode">
              <Translate contentKey="crawlerBackendApp.errorMessage.errorCode">Error Code</Translate>
            </span>
          </dt>
          <dd>{errorMessageEntity.errorCode}</dd>
          <dt>
            <span id="message">
              <Translate contentKey="crawlerBackendApp.errorMessage.message">Message</Translate>
            </span>
          </dt>
          <dd>{errorMessageEntity.message}</dd>
          <dt>
            <span id="errorName">
              <Translate contentKey="crawlerBackendApp.errorMessage.errorName">Error Name</Translate>
            </span>
          </dt>
          <dd>{errorMessageEntity.errorName}</dd>
        </dl>
        <Button tag={Link} to="/error-message" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/error-message/${errorMessageEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ErrorMessageDetail;
